import {
  SHOW_HAMBURGER_MENU,
  HIDE_HAMBURGER_MENU,
  SHOW_SEARCH_FORM,
  HIDE_SEARCH_FORM,
} from '../actionTypes';

export const showHamburgerMenu = () => ({
  type: SHOW_HAMBURGER_MENU,
});

export const hideHamburgerMenu = () => ({
  type: HIDE_HAMBURGER_MENU,
});

export const showSearchForm = () => ({
  type: SHOW_SEARCH_FORM,
});

export const hideSearchForm = () => ({
  type: HIDE_SEARCH_FORM,
});
